<template>
  <a-card :bordered="false">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      调仓操作
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="扫码类型" name='scan_type'>
        <a-radio-group v-model:value="form.scan_type" @change='form.code_sn = ""'>
          <a-radio :value="1">正常扫码</a-radio>
          <a-radio :value="2">回退扫码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="扫描二维码" name='code_sn'>
        <a-input style="width: 380px;margin-right: 10px;" v-model:value="form.code_sn" @pressEnter='scanCode'></a-input>
        <a-button class='m-r-10' type="primary" @click='scanCode' :loading='submitLoading'>添加</a-button>
        <a-tooltip placement='right'>
          <template #title>
            <p>1、点击“添加”后数据直接保存。如果使用扫描枪设备，不需要点击“添加”按钮，设备扫描完成会自动保存。</p>
            <p>2、使用扫描枪扫描时注意先将“光标”放到输入框中。（鼠标点一下输入框）</p>
            <p>3、程序自带提示音，会根据录入结果提示对应的声音，方便盲扫，请确保电脑带有声音播放功能。</p>
          </template>
          <InfoCircleOutlined class="fz-18" />
        </a-tooltip>
        <p class="s_c999">录入的二维码不是最高级别，系统将自动进行拆箱操作，把关联的上级二维码无效化</p>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 2}" v-if='showResult'>
        <a-card>
          <p class="s_lin_h30">扫码结果：</p>
          <p class="s_lin_h30">
            <span v-if='form.scan_type == 1'>{{resultCode == 0 ? '调仓成功！':'调仓失败！'}}</span>
            <span v-else>{{resultCode == 0 ? '回退成功！':'回退失败！'}}</span>
          </p>
          <p class="s_lin_h30" v-if='resultCode != 0'>失败原因：</p>
          <p class="s_lin_h30" v-if='resultCode != 0'>{{resultMsg}}</p>
        </a-card>
      </a-form-item>
      <a-descriptions :column='1' title="调仓单详情" class="m-t-20">
        <a-descriptions-item label="调出仓库">{{orderData.transfer_warehouse_name}}</a-descriptions-item>
        <a-descriptions-item label="调入仓库">{{orderData.transfer_to_warehouse_name}}</a-descriptions-item>
        <a-descriptions-item label="调仓单号">{{orderData.transfer_warehousing_sn}}</a-descriptions-item>
      </a-descriptions>
      <p class="fz-16 s_font_b m-t-20">商品详情</p>
      <a-table class='m-t-20' :pagination='false' :loading='loading' bordered rowKey='id' :columns='columns'
        :data-source='orderData.product'>
        <template v-slot:gift_name="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
            </template>
            <template #description>
              <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="link" @click='showCode = true;itemId = record.product_id;sku_sn = record.product_sku_sn'>查看出货二维码</a-button>
        </template>
      </a-table>
      <div class="m-t-25">
        <a-button class="width-100 m-r-20" block @click="onCancel">取消调仓</a-button>
        <a-button class="width-100 m-r-20" block type="primary" @click="onSubmit('all')">确定调仓</a-button>
        <a-button type="primary" @click="onSubmit('part')">确定部分调仓</a-button>
      </div>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer='null'>
    <template #title>
      <span class="fz-16">出库二维码</span>
      <span class="fz-14 s_c999">（进行拆箱发货的小标，删除后关联的中标和大标依然无效）</span>
    </template>  
    <shippingCode :id='itemId' :showLast='false' :sn='orderData.transfer_warehousing_sn' :sku_sn='sku_sn' type='transfer'></shippingCode>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { generateNumber } from "@/utils/utils";
  import store from "@/store";
  import { getTransferWarehousingMore, setTransferWarehousing, setTransferWarehousingCode,delTransferWarehousingCode } from "@/api/antiFleeing";
  import shippingCode from '../components/shippingCode.vue'
  let defForm = {
    scan_type: 1,
    code_sn: '',
  };
  export default {
    components: { LeftOutlined,InfoCircleOutlined,shippingCode },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const state = reactive({
        submitLoading:false,
        itemId:'',
        sku_sn:'',
        info: store.state.user.info,
        orderData:{},
        labelCol: {span: 2},
        wrapperCol: {span: 12},
        goodList:[],
        showCode:false,
        showResult:false,
        resultCode:'', //扫码结果code
        resultMsg:'', // 扫码结果提示语
        rules: {
          scan_type:[
            { required: true,  message: '请选择扫码类型',type:'number'}
          ],
          code_sn:[
            { required: true,  message: '二维码不能为空',}
          ],
        },
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "数量",
            dataIndex: "transfer_warehousing_num",
            key: "transfer_warehousing_num",
          },
          {
            title: "出库数量",
            dataIndex: "transfer_warehousing_real_num",
            key: "transfer_warehousing_real_num",
          },
          {
            title: "操作",
            key: "action",
            slots: { customRender: "action" }
          }
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      //获取详情
      const initData = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getTransferWarehousingMore( $route.query.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.orderData = res.data;
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //取消
      const onCancel = () =>{
        $Modal.confirm({
          centered: true,
          title: '退出调仓？',
          content: '退出后扫码出库商品将取消出库，进行拆箱发货的中标和大标依然无效',
          async onOk() {
            const hide = message.loading("正在加载中...", 0);
            let res = await delTransferWarehousingCode( state.orderData.transfer_warehousing_sn ).then((res) => res.data).catch(error => error);
            if (iscode(res)) {
              $router.go(-1)
            } else {
              message.error(res.msg);
            }
            setTimeout(hide);
          }
        })
      }
      //扫码
      const scanCode = () =>{
        ruleForm.value.validate().then(async() => {
          const hide = message.loading("正在加载中...", 0);
          state.submitLoading = true;
          let res = await setTransferWarehousingCode({ ...form.value,id:state.orderData.transfer_warehousing_sn}).then((res) => res.data).catch(error => error);
          if (iscode(res)) {
            message.success(res.msg);
          } else {
            message.error(res.msg);
          }
          state.resultCode = res.code
          state.resultMsg = res.msg
          state.showResult = true
          form.value.code_sn = ''
          initData();
          setTimeout(hide);
          state.submitLoading = false;
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      //提交
      const onSubmit = (text) => {
        $Modal.confirm({
          centered: true,
          title: text == 'all'?'确定调仓？':'确定部分调仓？',
          content: text == 'all'?'':'确定后剩余没有调仓的商品将生成一张新调仓单',
          async onOk() {
            const hide = message.loading("正在加载中...", 0);
            let res = await setTransferWarehousing({ is_part:text == 'all' ? 0:1,id:state.orderData.transfer_warehousing_sn}).then((res) => res.data).catch(error => error);
            if (iscode(res)) {
              message.success(res.msg);
              setTimeout(() => {
                $router.go(-1);
              }, 2000);
            } else {
              message.error(res.msg);
            }
            setTimeout(hide);
          }
        })
      };
      onMounted(() => {
        initData();
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        onSubmit,
        onCancel,
        scanCode
      };
    },
  };
</script>